import { render, staticRenderFns } from "./ShowWpsFile.vue?vue&type=template&id=797ed47c&scoped=true"
import script from "./ShowWpsFile.vue?vue&type=script&lang=js"
export * from "./ShowWpsFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ed47c",
  null
  
)

export default component.exports